module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-120x120-f5e3f9835df8baa5e70a029df7e8c7b4.png";